import React from 'react';
import { WhatsappLogo } from '@phosphor-icons/react';
import { Button } from './ui/button';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';

export default function WhatsAppSendConfirmationDialog({
  open,
  onOpenChange,
  onConfirm,
  title = 'Send WhatsApp message?',
  description = 'This will send a WhatsApp message to the selected recipients.',
  confirmLabel = 'Send message',
  disabled = false,
  testId = 'confirm-whatsapp-send-btn',
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <WhatsappLogo className="h-5 w-5 text-green-600" weight="fill" />
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={disabled}>Cancel</AlertDialogCancel>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={disabled}
            className="bg-green-600 text-white hover:bg-green-700"
            data-testid={testId}
          >
            <WhatsappLogo className="mr-2 h-4 w-4" weight="fill" />
            {confirmLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
